import { render, staticRenderFns } from "./studentexam.vue?vue&type=template&id=e526ef4e&scoped=true&"
import script from "./studentexam.vue?vue&type=script&lang=js&"
export * from "./studentexam.vue?vue&type=script&lang=js&"
import style0 from "./studentexam.vue?vue&type=style&index=0&id=e526ef4e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e526ef4e",
  null
  
)

export default component.exports